import React from 'react';
import {
    fieldGenerator,
    getErrorOnField,
    // getValidateStatus,
} from "utilities/form";
import PropTypes from "prop-types";
import { E_NACH_FORM_FIELDS } from 'constants/form-fields';
import cx from "classnames";
import { Row, Form, Button, Col, Spin, Tag, message, Upload, Icon, Modal, Input } from 'antd';
import { NACH_MODES_TYPE } from 'constants/enums'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { CaseService } from '../services';
import { STATE_STATUS } from '../constants';
import ConfirmButton from '../components/confirm-button';
import { Map, Record } from 'immutable';
import { NACH_STATUS } from '../constants/enums';


class NachMandateForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    state = {
        // termLoanInstallment: (this.props.nachMandateStatusResponse.getIn([ 'nach_details' ,'nach_cheque_details']) || [{}, {}, {}]),
        fileList: [],
        termLoanInstallment : [{},{},{}],
        uploadLoader: false,
        cancelNachLoader: false,
        loading: false
    }

    componentDidMount() {
        if(this.props.nachMandateStatusResponse.size || Record.isRecord(this.props.nachMandateStatusResponse)){
            this.setState({
                termLoanInstallment: (this.props.nachMandateStatusResponse.getIn([ 'nach_details' ,'nach_cheque_details']) || this.props.nachMandateStatusResponse.get( 'term_loan_instalment', [])?.filter(_ => new Date(_.due_date).getDate() == this.props.currentEmiDate)) || [{}, {}, {}],
            })
        }
       
    }


    getCaseEnachDetails = (e, mandate_type) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const payload = {
                    mandate_type,
                    bank_account_id : this.props.bank_account['id'],
                    associate_id: this.props.form.getFieldValue('associate'),
                    emi_date: this.props.currentEmiDate
                }
                this.props.onSubmit(payload, this.props.form.getFieldsValue());
            }
        });

    }

    copyToClipboard = (url) => {
        navigator.clipboard.writeText(url);
        message.success("Copied to clipboard");
    }

    handleInputChange = (index, field, value) => {
        const updatedInstallements = [...this.state.termLoanInstallment];
        updatedInstallements[index] = {
            ...updatedInstallements[index],
            [field]: value
        };
        this.setState({ termLoanInstallment: updatedInstallements });
    }

    updateNoNachPDC = () => {

        const emi_date =  this.props.nachMandateStatusResponse.getEmiDate();
        const isValid = this.state.termLoanInstallment.every(instalment => {
            const isNameValid = instalment.name && instalment.name.trim() !== '';
            const isChequeNumberValid = instalment.cheque_number && /^\d{6}$/.test(instalment.cheque_number);

            if (!isNameValid) message.error("Name cannot be empty or just whitespace");
            if (!isChequeNumberValid) message.error("Cheque number must be numeric and exactly 6 digits");

            return isNameValid && isChequeNumberValid;
        });

        if (!isValid) return;
        this.setState({
            loading: true
        })
        CaseService.noNachPDCTrigger(this.props.caseId, emi_date, this.state.termLoanInstallment.map(_ => ({
            "id": _.id,
            "name": _.name,
            "emi_amount": _.emi_amount,
            "cheque_number": _.cheque_number
        })))
            .then((resp) => {
                message.success("Nach Detail Updated")
                this.setState({
                    loading: false
                })
            })
            .catch((err) => {
                console.log("err", err);
                this.setState({
                    loading: false
                })
            })
    }

    handleUpload = (file) => {
        this.setState({
            fileList: [file]
        })
        const { nachMandateStatusResponse }  = this.props;
        const current_emi_date = nachMandateStatusResponse.getEmiDate()
        console.log("current_emi_date", current_emi_date);
        Modal.confirm({
            title: 'Are you sure you want to Upload Physical Enach',
            content: this.props.description,
            okText: 'Confirm',
            cancelText: 'Cancel',
            onOk: (close) => {
                this.setState({
                    uploadLoader: true
                })
                const formData = new FormData();
                formData.append('associate_id', this.props.form.getFieldValue('associate'))
                formData.append('account_id', this.props.bank_account['id']);
                formData.append('emi_date', current_emi_date);
                formData.append('file', file);

                CaseService.uploadPhysicalNach(this.props.caseId, formData)
                    .then((resp) => {
                        this.setState({
                            uploadLoader: false,
                            fileList: []
                        })
                        message.success(`Physical Mandate Triggered Successfully`);

                    })
                    .catch((err) => {
                        this.setState({
                            uploadLoader: false,
                            fileList: []
                        })
                        message.error(err['Message']['data']['message'] || "Something Went Wrong");
                    })
                close()
            },

        });
        return false;
    };


    cancelNachMandate = () => {
        this.setState({
            cancelNachLoader: true
        })
        const nachMandateStatusResponse = this.props.nachMandateStatusResponse
        const current_emi_date = nachMandateStatusResponse.getEmiDate()

        CaseService.cancelNachMandate(this.props.caseId, nachMandateStatusResponse.getIn(['nach_details', 'companybank_nach_id']) , current_emi_date)
            .then((response) => {
                message.success("E-Nach Successfully Cancelled")
                this.props.updateNachData()
                this.setState({
                    cancelNachLoader: false
                })
            })
            .catch((err) => {
                message.error("E-Nach Cancel Request Failed")
                this.setState({
                    cancelNachLoader: false
                })
            })
    }


    render() {
        console.log("this.props.nachMandateStatusRespons renfet", this.props.nachMandateStatusResponse.toJS())
        const { nachMandateStatusResponse , currentEmiDate}  = this.props;
        const nachDocument = nachMandateStatusResponse && nachMandateStatusResponse.getIn(['data', 'document_upload_status'], "");
        const { caseAssociates, loading } = this.props;
        const mandateTypeFormValue = this.props.form.getFieldValue('mandate_type');
        console.log("mandateTypeFormValue", mandateTypeFormValue);
        const disableTriggerButton = nachMandateStatusResponse &&  [NACH_STATUS.get('VERIFIED'), NACH_STATUS.get('BANK_CONFIRMED')].includes(nachMandateStatusResponse.getIn(['nach_details', 'nach_status']));
        const { fileList, uploadLoader, termLoanInstallment } = this.state;
        const current_emi_date = currentEmiDate

        const payload = {
            mandate_type: NACH_MODES_TYPE.getIn(["NO_NACH_PDC_ONLY", "value"]),
            account: nachMandateStatusResponse && nachMandateStatusResponse.getIn(['bank_details', 'account_number']),
            associate_id: this.props.form.getFieldValue('associate'),
            emi_date : current_emi_date
        }
        const disabledPerm= [57,11].includes(this.props.currentCaseTaskStageId?.[0]?.this_stage) && this.props.user?.groups?.find(el=>el.id ===68);
        return (
            <Form
                layout={"vertical"}
                className={cx("form", "p-10", "br-3")}
            >
                <h3>{this.props.schemeType == "Term Loan" ? `E-NACH - ${current_emi_date || ''}` : "Security NACH"}
                    {nachMandateStatusResponse.getIn(['nach_details', 'nach_status']) == NACH_STATUS.get('VERIFIED')
                        ? <span className='ml-10'><Tag color="green">Verified</Tag></span>
                        : nachMandateStatusResponse.getIn(['nach_details', 'nach_status']) == NACH_STATUS.get('BANK_CONFIRMED')
                            ? <span className='ml-10'><Tag color="green">Bank Confirmed</Tag></span> : ""}
                </h3>
                {E_NACH_FORM_FIELDS(caseAssociates).map((field, fieldName) => {
                    if (disabledPerm) {
                        field.disabled = false;
                    }
                    return <Col span={8} offset={field.offset || 0}>

                        {this.fieldGenerator(
                            fieldName,
                            field,
                            this.getErrorOnField(fieldName)
                        )()}
                    </Col>
                }
                ).toList()}
                {console.log("disableTriggerButton", disableTriggerButton , '---' , nachMandateStatusResponse.getIn(['nach_details', 'mandate_type']))}
                {this.props.form.getFieldValue('associate') != null && <Spin spinning={loading}><Col span={24}>
                    {mandateTypeFormValue == NACH_MODES_TYPE.getIn(["API_MANDATE", "value"]) ?
                        <>
                            <Button
                                disabled={disableTriggerButton || mandateTypeFormValue == nachMandateStatusResponse.getIn(['nach_details', 'mandate_type'])}
                                type="primary"
                                onClick={(e) => this.getCaseEnachDetails(e, NACH_MODES_TYPE.getIn(["API_MANDATE", "value"]))}>
                                Trigger
                            </Button>
                            {disableTriggerButton && <Button disabled={!disabledPerm} className='ml-05' loading={this.state.cancelNachLoader} onClick={this.cancelNachMandate}>
                                Cancel Nach
                            </Button>}
                            <Button
                                type="link"
                                disabled={nachMandateStatusResponse.size ? !nachMandateStatusResponse.getNachLink() : false} onClick={() => this.copyToClipboard(nachMandateStatusResponse.getNachLink())}><FontAwesomeIcon icon={faCopy} />
                            </Button>
                        </>
                        : mandateTypeFormValue == NACH_MODES_TYPE.getIn(["PHYSICAL_MANDATE", "value"]) ?
                            <>
                                <Row align="middle" style={{ display: "flex", flexWrap: "nowrap", gap: "10px", margin: "10px" }}>
                                    <Button
                                        disabled={disableTriggerButton || mandateTypeFormValue == nachMandateStatusResponse.getIn(['nach_details', 'mandate_type'])}
                                        type="primary"
                                        htmlType="submit"
                                        onClick={(e) =>
                                            this.getCaseEnachDetails(
                                                e,
                                                NACH_MODES_TYPE.getIn(["PHYSICAL_MANDATE", "value"])
                                            )
                                        }
                                    >
                                        Trigger
                                    </Button>
                                    {disableTriggerButton && (
                                        <Button
                                            loading={this.state.cancelNachLoader}
                                            onClick={this.cancelNachMandate}
                                        >
                                            Cancel Nach
                                        </Button>
                                    )}
                                    <Tag color="magenta">
                                        {nachDocument ? "Document Uploaded" : "Document Pending"}
                                    </Tag>
                                    {nachDocument && (
                                        <a href={nachDocument} target="_blank" download>
                                            <Button type="link">Download</Button>
                                        </a>)}
                                    <Spin spinning={uploadLoader}>
                                        <Upload
                                            beforeUpload={this.handleUpload}
                                            multiple={false}
                                            fileList={fileList}
                                            showUploadList={true}
                                        >
                                            <Button disabled={!disabledPerm}>
                                                <Icon type="upload" /> Click to Select File
                                            </Button>
                                        </Upload>
                                    </Spin>
                                </Row>
                            </>
                            // : mandateTypeFormValue == NACH_MODES_TYPE.getIn(["NO_NACH_PDC_ONLY", "value"]) && nachMandateStatusResponse ?
                            : mandateTypeFormValue == NACH_MODES_TYPE.getIn(["NO_NACH_PDC_ONLY", "value"])&& nachMandateStatusResponse && (this.props.schemeType == 'Term Loan' || [279, 252, 439].includes(this.props.user.id)) ?
                                <Spin spinning={this.state.loading}>
                                    <ConfirmButton
                                        label={"Generate"}
                                        disabled={disableTriggerButton}
                                        descriptionColor={[NACH_STATUS.get('VERIFIED'), NACH_STATUS.get('BANK_CONFIRMED')].includes(nachMandateStatusResponse.size ? nachMandateStatusResponse.getNachStatus() : '') ? 'red' : null}
                                        onConfirm={() => this.props.triggerEnach(payload, this.props.form.getFieldsValue())}
                                        description={
                                            [NACH_STATUS.get('VERIFIED'), NACH_STATUS.get('BANK_CONFIRMED')].includes(nachMandateStatusResponse.size ? nachMandateStatusResponse.getNachStatus() : '') ?
                                                `NACH is already registered via ${nachMandateStatusResponse.getMandateTypeLabel()} mode. Do you wish to initiate again?` :
                                                "Are you sure you want to Trigger No Nach PDC"}
                                        type="primary"
                                    />
                                    {disableTriggerButton && <Button className='ml-05' loading={this.state.cancelNachLoader} onClick={this.cancelNachMandate}>
                                        Cancel Nach
                                    </Button>}
                                    {((nachMandateStatusResponse.getIn(['nach_details','nach_cheque_details']) || nachMandateStatusResponse.getIn(['term_loan_instalment'])) || (this.props.schemeType == 'Default Scheme' && nachMandateStatusResponse.get('nach_details'))) && <Row>
                                        <Col span={24} className='text-right'>
                                            <Button
                                                type="primary"
                                                disabled={this.props.schemeType == 'Default Scheme' ? this.state.termLoanInstallment.filter(_ => !_.name || !_.cheque_number).length : (disableTriggerButton || this.state.termLoanInstallment.filter(_ => !_.name || !_.emi_amount || !_.cheque_number).length)}
                                                onClick={this.updateNoNachPDC}>
                                                Submit
                                            </Button>
                                        </Col>
                                        {this.props.schemeType == 'Default Scheme' ?
                                            <table style={{ height: 400, display: 'inline-block', overflow: 'scroll' }}>
                                                <thead>
                                                    <th style={{ width: 150 }}>S. No.</th>
                                                    <th style={{ width: 200 }}>Beneficiary Name</th>
                                                    <th style={{ width: 200 }}>Cheque Number</th>
                                                </thead>
                                                <tbody>
                                                    {[1, 2, 3].map((installement, index) => {
                                                        return <tr>
                                                            <td> <p>{index + 1}</p></td>
                                                            <td>
                                                                <Input type='text'
                                                                    value={(termLoanInstallment.length && termLoanInstallment[index]) ? termLoanInstallment[index].name : ''}
                                                                    onChange={(e) => this.handleInputChange(index, 'name', e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Input type='text'
                                                                    value={(termLoanInstallment.length && termLoanInstallment[index]) ? termLoanInstallment[index].cheque_number : ''}
                                                                    onChange={(e) => this.handleInputChange(index, 'cheque_number', e.target.value)}
                                                                />
                                                            </td>

                                                        </tr>
                                                    })}
                                                </tbody>
                                            </table>
                                            : <Col span="24">
                                                <table style={{ height: 400, display: 'inline-block', overflow: 'scroll' }}>
                                                    <thead>
                                                        <th style={{ width: 150 }}>EMI Date</th>
                                                        <th style={{ width: 200 }}>Beneficiary Name</th>
                                                        <th style={{ width: 200 }}>Cheque Number</th>
                                                        <th style={{ width: 200 }}>Amount</th>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.termLoanInstallment && this.state.termLoanInstallment.filter(_ => new Date(_.due_date).getDate() == current_emi_date ).map((installement, index) => {
                                                            return <tr>
                                                                <td> <p>{installement.due_date}</p></td>
                                                                <td>
                                                                    <Input type='text'
                                                                        value={installement.name}
                                                                        onChange={(e) => this.handleInputChange(index, 'name', e.target.value)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <Input type='text'
                                                                        value={installement.cheque_number}
                                                                        onChange={(e) => this.handleInputChange(index, 'cheque_number', e.target.value)}
                                                                    />
                                                                </td>
                                                                <td><Input
                                                                    type='text'
                                                                    value={installement.emi_amount}
                                                                    onChange={(e) => this.handleInputChange(index, 'emi_amount', e.target.value)}
                                                                /></td>
                                                            </tr>
                                                        })}
                                                    </tbody>
                                                </table>
                                            </Col>}
                                    </Row>}
                                </Spin>
                                : <></>
                    }
                </Col></Spin>}
                {this.props.schemeType != 'Term Loan' && mandateTypeFormValue == NACH_MODES_TYPE.getIn(["NO_NACH_PDC_ONLY", "value"]) && <Col span={24}><h5>No Nach PDC is disabled for Non Term Loan</h5></Col>}
            </Form>
        )
    }
}

NachMandateForm.defaultProps = {
    caseAssociates: [],
    bank_account: {}
};

NachMandateForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.object,
    saveFeeDetails: PropTypes.func,
    businessProgramId: PropTypes.number,
    parentProgramData: PropTypes.object,
    caseAssociates: PropTypes.array,
    nachStatus: PropTypes.string,
    loading: PropTypes.bool,
    bank_account: PropTypes.object
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
            values
                .toSeq()
                .toMap()
                .map((value, key) => {
                    console.log('value, key', value, key);
                    if (key === "residing_since") {
                        return Form.createFormField({
                            value: !value ? !value || isNaN(value.date()) ? null : value : moment(value)
                        });
                    }
                    return Form.createFormField({
                        value
                    });
                })
                .toJS()
    }
})(NachMandateForm);

``